exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.4@core-js/library/modules/_wks-ext.js
// module id = OCCA
// module chunks = 0